import { NoContextImage } from '@/components/Image';
import { useWindowStore } from '@/stores/useWindowStore';

export function imageParser(node, children, parent, styles, colorScheme) {
    const src = node.attributes?.src;
    const {isMobile, dimensions: {width: windowWidth}} = useWindowStore.getState();

    if (!src) 
        return null;
    
    const rawAlt = node.attributes?.alt || "";

    const parts = rawAlt.split("|").map(s => s.trim()).filter(Boolean);
    const alt = parts[0] ?? ""; // First part is the alt text, the rest are options in key=value format

    const opts = Object.fromEntries(
        parts.slice(1).map(p => {
            const [k, v] = p.split("=").map(x => x?.trim());
            return [k, v];
        })
    );

    const height = opts.height ? Number(opts.height) : undefined;

    const width = isMobile 
        ?   '100%'
        :   opts.width === "100%" ? "100%" : (opts.width ? Number(opts.width) : "100%");

    const aspectRatio = width / height ?? 16/9;

    const fit = opts.fit || "cover";

    let newSource = src;

    if (width != '100%' && height != null) {
        newSource = newSource?.replace('cover=16:9', `cover=${width}:${height}`);
    }

    newSource = newSource?.replace('resize=1200', `resize=600`);

    return (
        <NoContextImage
            source={{ uri: newSource }}
            style={{ width: width, maxWidth: 600, aspectRatio: isNaN(aspectRatio) ? 16/9 : aspectRatio, marginVertical: 15 }}
            contentFit={fit}
            priority="high"
            accessibilityLabel={alt ?? "Image"}
            accessibilityRole="image"
        />
    );
}